import { render, staticRenderFns } from "./MemberDashBoard.vue?vue&type=template&id=72685331&scoped=true&"
import script from "./MemberDashBoard.vue?vue&type=script&lang=ts&"
export * from "./MemberDashBoard.vue?vue&type=script&lang=ts&"
import style0 from "./MemberDashBoard.vue?vue&type=style&index=0&id=72685331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72685331",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VContent,VIcon,VRow,VSimpleTable,VSpacer})
